import FanToleranceWidget from "./Fan";
import "@iframe-resizer/child";

const FanToleranceWidgetPage = () => {
  return <FanToleranceWidget />;
};

export default FanToleranceWidgetPage;
